(function () {
  var canvas = document.querySelector("[data-ss-topo]");
  if (!canvas || canvas.dataset.ssTopoReady) return;
  canvas.dataset.ssTopoReady = "1";

  var ctx = canvas.getContext("2d", { alpha: true });
  if (!ctx) return;

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var F3 = 1 / 3;
  var G3 = 1 / 6;
  var grad3 = [
    [1, 1, 0], [-1, 1, 0], [1, -1, 0], [-1, -1, 0],
    [1, 0, 1], [-1, 0, 1], [1, 0, -1], [-1, 0, -1],
    [0, 1, 1], [0, -1, 1], [0, 1, -1], [0, -1, -1]
  ];
  var src = [151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180];
  var perm = new Uint8Array(512);
  for (var i = 0; i < 512; i++) perm[i] = src[i & 255];

  function dot(g, x, y, z) {
    return g[0] * x + g[1] * y + g[2] * z;
  }

  function simplex3(xin, yin, zin) {
    var s = (xin + yin + zin) * F3;
    var i = Math.floor(xin + s);
    var j = Math.floor(yin + s);
    var k = Math.floor(zin + s);
    var t = (i + j + k) * G3;
    var x0 = xin - (i - t);
    var y0 = yin - (j - t);
    var z0 = zin - (k - t);
    var i1, j1, k1, i2, j2, k2;
    if (x0 >= y0) {
      if (y0 >= z0) { i1 = 1; j1 = 0; k1 = 0; i2 = 1; j2 = 1; k2 = 0; }
      else if (x0 >= z0) { i1 = 1; j1 = 0; k1 = 0; i2 = 1; j2 = 0; k2 = 1; }
      else { i1 = 0; j1 = 0; k1 = 1; i2 = 1; j2 = 0; k2 = 1; }
    } else if (y0 < z0) { i1 = 0; j1 = 0; k1 = 1; i2 = 0; j2 = 1; k2 = 1; }
    else if (x0 < z0) { i1 = 0; j1 = 1; k1 = 0; i2 = 0; j2 = 1; k2 = 1; }
    else { i1 = 0; j1 = 1; k1 = 0; i2 = 1; j2 = 1; k2 = 0; }

    var x1 = x0 - i1 + G3;
    var y1 = y0 - j1 + G3;
    var z1 = z0 - k1 + G3;
    var x2 = x0 - i2 + 2 * G3;
    var y2 = y0 - j2 + 2 * G3;
    var z2 = z0 - k2 + 2 * G3;
    var x3 = x0 - 1 + 3 * G3;
    var y3 = y0 - 1 + 3 * G3;
    var z3 = z0 - 1 + 3 * G3;
    var ii = i & 255;
    var jj = j & 255;
    var kk = k & 255;
    var gi0 = perm[ii + perm[jj + perm[kk]]] % 12;
    var gi1 = perm[ii + i1 + perm[jj + j1 + perm[kk + k1]]] % 12;
    var gi2 = perm[ii + i2 + perm[jj + j2 + perm[kk + k2]]] % 12;
    var gi3 = perm[ii + 1 + perm[jj + 1 + perm[kk + 1]]] % 12;
    var n0 = 0, n1 = 0, n2 = 0, n3 = 0;
    var t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
    if (t0 > 0) { t0 *= t0; n0 = t0 * t0 * dot(grad3[gi0], x0, y0, z0); }
    var t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
    if (t1 > 0) { t1 *= t1; n1 = t1 * t1 * dot(grad3[gi1], x1, y1, z1); }
    var t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
    if (t2 > 0) { t2 *= t2; n2 = t2 * t2 * dot(grad3[gi2], x2, y2, z2); }
    var t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
    if (t3 > 0) { t3 *= t3; n3 = t3 * t3 * dot(grad3[gi3], x3, y3, z3); }
    return 32 * (n0 + n1 + n2 + n3);
  }

  function elevation(x, y, z, freq, amp) {
    return simplex3(x * freq, y * freq, z) * amp;
  }

  function lerp(a, b, va, vb, level) {
    var d = vb - va;
    var t = d === 0 ? 0.5 : (level - va) / d;
    if (t < 0) t = 0;
    else if (t > 1) t = 1;
    return a + (b - a) * t;
  }

  function edgePoint(c, r, edge, level, grid, cell) {
    var tl = grid[r][c];
    var tr = grid[r][c + 1];
    var br = grid[r + 1][c + 1];
    var bl = grid[r + 1][c];
    var x = c * cell;
    var y = r * cell;
    if (edge === 0) return [lerp(x, x + cell, tl, tr, level), y];
    if (edge === 1) return [x + cell, lerp(y, y + cell, tr, br, level)];
    if (edge === 2) return [lerp(x, x + cell, bl, br, level), y + cell];
    return [x, lerp(y, y + cell, tl, bl, level)];
  }

  function segmentsFor(mask, centerHigh) {
    if (mask === 1) return [[3, 0]];
    if (mask === 2) return [[0, 1]];
    if (mask === 3) return [[3, 1]];
    if (mask === 4) return [[1, 2]];
    if (mask === 5) return centerHigh ? [[0, 1], [2, 3]] : [[3, 0], [1, 2]];
    if (mask === 6) return [[0, 2]];
    if (mask === 7) return [[3, 2]];
    if (mask === 8) return [[2, 3]];
    if (mask === 9) return [[0, 2]];
    if (mask === 10) return centerHigh ? [[3, 0], [1, 2]] : [[0, 1], [2, 3]];
    if (mask === 11) return [[1, 2]];
    if (mask === 12) return [[1, 3]];
    if (mask === 13) return [[0, 1]];
    if (mask === 14) return [[0, 3]];
    return [];
  }

  function keyOf(p) {
    return (Math.round(p[0] * 2)) + "," + (Math.round(p[1] * 2));
  }

  function stitch(segs) {
    var adj = new Map();
    for (var i = 0; i < segs.length; i++) {
      var k0 = keyOf(segs[i][0]);
      var k1 = keyOf(segs[i][1]);
      if (!adj.has(k0)) adj.set(k0, []);
      if (!adj.has(k1)) adj.set(k1, []);
      adj.get(k0).push({ i: i, end: 0 });
      adj.get(k1).push({ i: i, end: 1 });
    }
    var used = new Uint8Array(segs.length);
    var lines = [];
    for (var s = 0; s < segs.length; s++) {
      if (used[s]) continue;
      used[s] = 1;
      var line = [segs[s][0], segs[s][1]];
      var closed = false;
      var extend = function (front) {
        for (var guard = 0; guard < segs.length; guard++) {
          var end = front ? line[0] : line[line.length - 1];
          if (!front && line.length > 3 && keyOf(end) === keyOf(line[0])) {
            closed = true;
            return;
          }
          var opts = adj.get(keyOf(end));
          if (!opts) return;
          var nxt = null;
          for (var o = 0; o < opts.length; o++) {
            if (!used[opts[o].i]) { nxt = opts[o]; break; }
          }
          if (!nxt) return;
          used[nxt.i] = 1;
          var seg = segs[nxt.i];
          var point = nxt.end === 0 ? seg[1] : seg[0];
          if (front) line.unshift(point);
          else line.push(point);
        }
      };
      extend(false);
      if (!closed) extend(true);
      if (line.length > 3 && keyOf(line[0]) === keyOf(line[line.length - 1])) {
        closed = true;
        line.pop();
      }
      if (line.length > 2) lines.push({ pts: line, closed: closed });
    }
    return lines;
  }

  function contours(grid, cols, rows, cell, levels, r0, r1) {
    var lines = [];
    var rowStart = r0 || 0;
    var rowEnd = r1 == null ? rows : r1;
    for (var li = 0; li < levels.length; li++) {
      var level = levels[li];
      var segs = [];
      for (var r = rowStart; r < rowEnd; r++) {
        for (var c = 0; c < cols; c++) {
          var tl = grid[r][c];
          var tr = grid[r][c + 1];
          var br = grid[r + 1][c + 1];
          var bl = grid[r + 1][c];
          var mask = 0;
          if (tl >= level) mask |= 1;
          if (tr >= level) mask |= 2;
          if (br >= level) mask |= 4;
          if (bl >= level) mask |= 8;
          if (mask === 0 || mask === 15) continue;
          var pairs = segmentsFor(mask, (tl + tr + br + bl) / 4 >= level);
          for (var p = 0; p < pairs.length; p++) {
            segs.push([
              edgePoint(c, r, pairs[p][0], level, grid, cell),
              edgePoint(c, r, pairs[p][1], level, grid, cell)
            ]);
          }
        }
      }
      var stitched = stitch(segs);
      for (var n = 0; n < stitched.length; n++) lines.push(stitched[n]);
    }
    return lines;
  }

  function chaikin(pts, closed) {
    var n = pts.length;
    var out = [];
    var last = closed ? n : n - 1;
    for (var i = 0; i < last; i++) {
      var a = pts[i];
      var b = pts[(i + 1) % n];
      out.push([0.75 * a[0] + 0.25 * b[0], 0.75 * a[1] + 0.25 * b[1]]);
      out.push([0.25 * a[0] + 0.75 * b[0], 0.25 * a[1] + 0.75 * b[1]]);
    }
    if (!closed) {
      out.unshift(pts[0]);
      out.push(pts[n - 1]);
    }
    return out;
  }

  function strokeLine(line) {
    var pts = line.pts;
    var closed = line.closed;
    for (var pass = 0; pass < 2; pass++) pts = chaikin(pts, closed);
    var n = pts.length;
    if (n < 2) return;
    ctx.beginPath();
    if (n === 2) {
      ctx.moveTo(pts[0][0], pts[0][1]);
      ctx.lineTo(pts[1][0], pts[1][1]);
      ctx.stroke();
      return;
    }
    if (closed) {
      ctx.moveTo((pts[n - 1][0] + pts[0][0]) / 2, (pts[n - 1][1] + pts[0][1]) / 2);
      for (var i = 0; i < n; i++) {
        var p = pts[i];
        var q = pts[(i + 1) % n];
        ctx.quadraticCurveTo(p[0], p[1], (p[0] + q[0]) / 2, (p[1] + q[1]) / 2);
      }
      ctx.closePath();
    } else {
      ctx.moveTo(pts[0][0], pts[0][1]);
      for (var j = 1; j < n - 1; j++) {
        var a = pts[j];
        var b = pts[j + 1];
        ctx.quadraticCurveTo(a[0], a[1], (a[0] + b[0]) / 2, (a[1] + b[1]) / 2);
      }
      ctx.lineTo(pts[n - 1][0], pts[n - 1][1]);
    }
    ctx.stroke();
  }

  function contourLevels(count, amp) {
    var lines = Math.max(2, count);
    var span = Math.max(0.05, amp) * 0.92;
    var step = (span * 2) / lines;
    var levels = [];
    for (var lv = -span + step * 0.5; lv < span; lv += step) levels.push(lv);
    return levels;
  }

  var cols = 0;
  var rows = 0;
  var cell = 16;
  var grid = null;
  var width = 0;
  var height = 0;
  var time = 0;
  var last = 0;
  var running = !reduced;
  var layer = canvas.closest(".ss-bg");

  function settings() {
    var lines = parseFloat(canvas.dataset.lines);
    var elevation = parseFloat(canvas.dataset.elevation);
    return {
      scale: parseFloat(canvas.dataset.scale) || 1,
      speed: parseFloat(canvas.dataset.speed) || 40,
      thickness: parseFloat(canvas.dataset.thickness) || 1.5,
      color: canvas.dataset.color || "#ffffff",
      colorEnd: canvas.dataset.colorEnd || canvas.dataset.color || "#ffb066",
      opacity: parseFloat(canvas.dataset.opacity),
      lines: isNaN(lines) ? 12 : lines,
      elevation: elevation > 2 ? elevation / 100 : (elevation > 0 ? elevation : 0.6)
    };
  }

  var viewLock = 0;

  function resize() {
    var w = canvas.clientWidth;
    var h = canvas.clientHeight;
    if (w < 2 || h < 2) return;
    if (grid && Math.abs(w - width) < 2 && Math.abs(h - height) < 80) return;
    var pixels = w * h;
    var narrow = w < 750;
    var dprCap = narrow ? 1 : (pixels > 1800000 ? 1 : 1.5);
    var dpr = Math.min(window.devicePixelRatio || 1, dprCap);
    var bw = Math.max(1, Math.round(w * dpr));
    var bh = Math.max(1, Math.round(h * dpr));
    if (canvas.width !== bw || canvas.height !== bh) {
      canvas.width = bw;
      canvas.height = bh;
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (!width || Math.abs(w - width) >= 2) viewLock = 0;
    width = w;
    height = h;
    covered = 0;
    cell = narrow ? 16 : 8;
    cols = Math.ceil(w / cell);
    rows = Math.ceil(h / cell);
    grid = new Array(rows + 1);
    for (var r = 0; r <= rows; r++) grid[r] = new Float32Array(cols + 1);
  }

  var queued = false;
  var covered = 0;
  var lastPaint = 0;
  var waitTimer = 0;

  function queue() {
    if (queued || waitTimer) return;
    if (width < 750 && lastPaint) {
      var wait = 33 - (performance.now() - lastPaint);
      if (wait > 4) {
        waitTimer = setTimeout(function () {
          waitTimer = 0;
          if (queued) return;
          queued = true;
          requestAnimationFrame(frame);
        }, wait);
        return;
      }
    }
    queued = true;
    requestAnimationFrame(frame);
  }

  function visibleSpan() {
    var rect = canvas.getBoundingClientRect();
    var scaleY = rect.height > 0 ? height / rect.height : 1;
    var vv = window.visualViewport;
    var vpTop = vv ? vv.offsetTop : 0;
    var vpH = vv ? vv.height : (window.innerHeight || height);
    var y0 = (vpTop - rect.top) * scaleY;
    var y1 = y0 + vpH * scaleY;
    var pad = Math.max(vpH, 480) * scaleY;
    return {
      r0: Math.max(0, Math.floor((y0 - pad) / cell) - 2),
      r1: Math.min(rows, Math.ceil((y1 + pad) / cell) + 2)
    };
  }

  function lineGradient(cfg) {
    var end = cfg.colorEnd || cfg.color;
    if (!end || end.toLowerCase() === String(cfg.color).toLowerCase()) return cfg.color;
    var rect = canvas.getBoundingClientRect();
    var scaleY = rect.height > 0 ? height / rect.height : 1;
    var vv = window.visualViewport;
    var vpTop = vv ? vv.offsetTop : 0;
    var vpH = vv ? vv.height : (window.innerHeight || height);
    var y0 = (vpTop - rect.top) * scaleY;
    var y1 = y0 + Math.max(1, vpH) * scaleY;
    var gradient = ctx.createLinearGradient(0, y0, 0, y1);
    gradient.addColorStop(0, cfg.color);
    gradient.addColorStop(1, end);
    return gradient;
  }

  function frame(now) {
    queued = false;
    if (document.hidden) return;
    if (!grid) resize();
    if (!grid) {
      if (running) queue();
      return;
    }
    if (width < 750) lastPaint = now;
    var cfg = settings();
    var speed = cfg.speed > 0 ? cfg.speed : 40;
    if (!last) last = now;
    var dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    if (running) time += dt * (0.85 / speed);

    if (!viewLock) {
      viewLock = Math.max(window.innerWidth || width, window.innerHeight || height);
    }
    var view = viewLock;
    var freq = 2.4 / ((view || Math.max(width, height)) * (cfg.scale || 1));
    var amp = cfg.elevation;
    var levels = contourLevels(cfg.lines, amp);

    function paint(r0, r1) {
      if (r1 <= r0) return;
      var top = Math.max(0, r0);
      var bot = Math.min(rows, r1);
      for (var r = top; r <= bot; r++) {
        var y = r * cell;
        var row = grid[r];
        for (var c = 0; c <= cols; c++) {
          row[c] = elevation(c * cell, y, time, freq, amp);
        }
      }
      var clearY = top * cell;
      var clearH = Math.min(height, (bot + 1) * cell) - clearY;
      ctx.clearRect(0, clearY, width, clearH);
      ctx.lineWidth = cfg.thickness;
      ctx.strokeStyle = lineGradient(cfg);
      ctx.globalAlpha = isNaN(cfg.opacity) ? 0.45 : cfg.opacity;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      var lines = contours(grid, cols, rows, cell, levels, top, bot);
      var minLen = cell * 3;
      for (var i = 0; i < lines.length; i++) {
        var pts = lines[i].pts;
        var len = 0;
        for (var p = 1; p < pts.length; p++) {
          var dx = pts[p][0] - pts[p - 1][0];
          var dy = pts[p][1] - pts[p - 1][1];
          len += Math.sqrt(dx * dx + dy * dy);
        }
        if (len >= minLen) strokeLine(lines[i]);
      }
      ctx.globalAlpha = 1;
    }

    var vis = visibleSpan();
    paint(vis.r0, vis.r1);
    if (covered < rows) {
      var fillEnd = Math.min(rows, covered + 60);
      if (fillEnd <= vis.r0 || covered >= vis.r1) paint(covered, fillEnd);
      covered = fillEnd;
    }

    if (running) queue();
  }

  var useScrollTimeline = false;
  try {
    useScrollTimeline = !!(window.CSS && CSS.supports("animation-timeline: scroll(root)"));
  } catch (err) {}

  var appliedRange = "";
  var maxScrollCached = 0;

  function measureMax() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var bottom = 0;
    var kids = document.body ? document.body.children : [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (!el || !el.getBoundingClientRect) continue;
      if (el.classList && (el.classList.contains("ss-bg") || el.classList.contains("ss-bg-clip"))) continue;
      var pos = window.getComputedStyle(el).position;
      if (pos === "fixed" || pos === "sticky") continue;
      var end = el.getBoundingClientRect().bottom + scrollY;
      if (end > bottom) bottom = end;
    }
    return Math.max(0, Math.round(bottom - (window.innerHeight || 0)));
  }

  function syncRange() {
    maxScrollCached = measureMax();
    var next = String(maxScrollCached);
    if (next === appliedRange) return;
    appliedRange = next;
    document.documentElement.style.setProperty("--ss-max-scroll", next);
  }

  function place() {
    if (!layer || useScrollTimeline) return;
    var maxScroll = Math.max(1, maxScrollCached);
    var scrollY = window.scrollY || window.pageYOffset || 0;
    if (scrollY < 0) scrollY = 0;
    else if (scrollY > maxScroll) scrollY = maxScroll;
    layer.style.transform = "translate3d(0," + (scrollY - 16 * (scrollY / maxScroll)) + "px,0)";
  }

  resize();
  syncRange();
  place();
  window.addEventListener("resize", function () {
    resize();
    syncRange();
    place();
  });
  window.addEventListener("load", function () {
    syncRange();
    place();
  });
  if (!useScrollTimeline) window.addEventListener("scroll", place, { passive: true });
  if (window.ResizeObserver && layer) {
    var observer = new ResizeObserver(function () { resize(); });
    observer.observe(layer);
    var contentObserver = new ResizeObserver(function () { syncRange(); });
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && (kids[i].classList.contains("ss-bg") || kids[i].classList.contains("ss-bg-clip"))) continue;
      contentObserver.observe(kids[i]);
    }
  }
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) queue();
  });
  if (!document.hidden) queue();
})();
